import React, { FC } from 'react';
import s from './toyCard.module.scss';
import cn from 'classnames';
import Skeleton from 'react-loading-skeleton';
import { useTranslation } from '@hooks/useTranslation';
import { Button } from '@components/UIKit/Button/Button';
interface Props {}
export const ToyCardLoading: FC<Props> = ({}) => {
  const {
    translate: tr
  } = useTranslation();
  return <div className={s.toyCard} data-sentry-component="ToyCardLoading" data-sentry-source-file="ToyCardLoading.tsx">
            <div className={s.toyCard__body}>
                <div className={s.toyCard__top}>
                    <div className={s.toyCard__row}>
                    </div>
                    <Skeleton className={s.toyCard__image} data-sentry-element="Skeleton" data-sentry-source-file="ToyCardLoading.tsx" />
                </div>
                <div className={s.toyCard__main}>
                    <div className={cn(s.toyCard__name, '_ellipsis')}>
                        {tr({
            id: 'btn.loading'
          })}
                    </div>
                    <div className={cn(s.toyCard__collection, '_ellipsis')}>
                        {tr({
            id: 'btn.loading'
          })}
                    </div>
                </div>

                <Button id='loading_button' color={'Black'} size={'medium'} loading data-sentry-element="Button" data-sentry-source-file="ToyCardLoading.tsx">
                    {tr({
          id: 'btn.loading'
        })}
                </Button>
            </div>
        </div>;
};